<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>用户</h2>
    </div>
    <div class="search-row">
      <input v-model="keyword" placeholder="搜索邮箱或 openid" @keyup.enter="search" />
      <button type="button" class="btn ghost sm" @click="search">搜索</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="message" class="ok">{{ message }}</p>

    <div class="user-layout">
      <div class="user-list">
        <button
          v-for="item in users"
          :key="item.id"
          type="button"
          class="user-row"
          :class="{ on: current && current.id === item.id }"
          @click="openUser(item.id)"
        >
          <strong>{{ item.nickname }}</strong>
          <span class="muted">{{ item.email }}</span>
          <span class="pts">积分 {{ (item.balances && item.balances.points) || 0 }}</span>
        </button>
        <p v-if="!users.length" class="muted">没有匹配用户</p>
        <ListPager
          :page="paging.page"
          :pages="paging.pages"
          :total="paging.total"
          @change="onPage"
        />
      </div>

      <div v-if="detail" class="user-detail">
        <h3>{{ detail.user.nickname }}</h3>
        <p class="muted">{{ detail.user.email }}</p>
        <p class="muted">openid {{ detail.user.wechat_openid || '未绑定' }}</p>
        <p class="ok">积分 {{ detail.balances.points }} · Token {{ detail.balances.tokens }}</p>

        <div class="form-grid">
          <label><span>补积分（可负）</span><input v-model.number="grant.points" type="number" /></label>
          <label><span>补 Token（可负）</span><input v-model.number="grant.tokens" type="number" /></label>
        </div>
        <label><span>备注</span><input v-model="grant.note" placeholder="如：客服补偿" /></label>
        <button type="button" class="btn primary" @click="submitGrant">手工补点</button>

        <h3>积分历史</h3>
        <div v-for="row in detail.ledger" :key="row.id" class="list-item">
          <div>
            <strong :class="{ plus: row.delta > 0, minus: row.delta < 0 }">
              {{ row.delta > 0 ? '+' : '' }}{{ row.delta }}
            </strong>
            <span class="muted"> · {{ actionLabel(row.action) }} · 余 {{ row.balance_after }}</span>
            <p class="muted">{{ formatLedgerTime(row.created_at) }}</p>
          </div>
        </div>
        <p v-if="!detail.ledger.length" class="muted">暂无流水</p>
        <ListPager
          :page="ledgerPaging.page"
          :pages="ledgerPaging.pages"
          :total="ledgerPaging.total"
          @change="onLedgerPage"
        />
      </div>
      <p v-else class="muted">点左侧用户查看积分与补点</p>
    </div>
  </section>
</template>

<script>
import { adminGrantCredits, adminListUsers, adminUserBilling } from '../../api/platformService'
import ListPager from '../../components/ListPager.vue'
import { actionLabel, formatLedgerTime } from '../../utils/ledgerLabels'

export default {
  name: 'AdminUsers',
  components: { ListPager },
  data() {
    return {
      keyword: '',
      users: [],
      paging: { page: 1, pages: 1, total: 0 },
      ledgerPaging: { page: 1, pages: 1, total: 0 },
      current: null,
      detail: null,
      grant: { points: 10, tokens: 0, note: '' },
      error: '',
      message: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    actionLabel,
    formatLedgerTime,
    search() {
      this.paging.page = 1
      return this.load()
    },
    onPage(page) {
      this.paging.page = page
      this.load()
    },
    async load() {
      this.error = ''
      try {
        const data = await adminListUsers({
          q: this.keyword.trim(),
          page: this.paging.page,
          per_page: 20
        })
        this.users = data.users || []
        this.paging = data.paging || { page: 1, pages: 1, total: 0 }
      } catch (err) {
        this.error = err.response?.data?.error || '加载用户失败'
      }
    },
    async openUser(id, ledgerPage) {
      this.error = ''
      this.message = ''
      if (this.current?.id !== id) this.ledgerPaging.page = 1
      if (ledgerPage) this.ledgerPaging.page = ledgerPage
      try {
        this.detail = await adminUserBilling(id, {
          page: this.ledgerPaging.page,
          per_page: 30
        })
        this.current = this.detail.user
        this.ledgerPaging = this.detail.ledger_paging || { page: 1, pages: 1, total: 0 }
        const hit = this.users.find((u) => u.id === id)
        if (hit) hit.balances = this.detail.balances
      } catch (err) {
        this.error = err.response?.data?.error || '加载用户详情失败'
      }
    },
    onLedgerPage(page) {
      if (!this.current) return
      this.openUser(this.current.id, page)
    },
    async submitGrant() {
      if (!this.current) return
      this.error = ''
      this.message = ''
      try {
        const result = await adminGrantCredits({
          user_id: this.current.id,
          points: this.grant.points,
          tokens: this.grant.tokens,
          note: this.grant.note
        })
        this.message = `已给 ${result.user.email} 补点`
        await this.load()
        await this.openUser(result.user.id, 1)
      } catch (err) {
        this.error = err.response?.data?.error || '补点失败'
      }
    }
  }
}
</script>

<style scoped>
.user-layout { display: grid; grid-template-columns: 280px minmax(0, 1fr); gap: 16px; align-items: start; }
.user-list { display: grid; gap: 6px; max-height: calc(100vh - 220px); overflow: auto; }
.user-row {
  text-align: left;
  border: 1px solid #e5e6eb;
  background: #fafbfc;
  border-radius: 6px;
  padding: 8px 10px;
  cursor: pointer;
  display: grid;
  gap: 2px;
}
.user-row.on { border-color: #165dff; background: #e8f3ff; }
.pts { font-size: 12px; color: #165dff; }
.plus { color: #00b42a; }
.minus { color: #f53f3f; }
@media (max-width: 960px) {
  .user-layout { grid-template-columns: 1fr; }
}
</style>
